/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

export const I18N = {
    de: {
        captureReload: {
            hoverTxt: 'Anderes Bild anzeigen'
        }
    },
    en: {
        captureReload: {
            hoverTxt: 'Show an alternative picture'
        }
    }
};
